import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "lots-catalog",
  class: "site-tabs site-tabs lots-catalog box-shadow"
}
const _hoisted_2 = { class: "catalog-header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "lots-controllers" }
const _hoisted_5 = { class: "all-lots-block tabs-content" }
const _hoisted_6 = {
  key: 0,
  class: "catalog-not-found-label"
}

import { computed, markRaw, nextTick, onMounted, reactive, ref, watch } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import Popup from "@/components/_partials/Popup.vue";
  import Swiper from "@/components/_partials/Swiper.vue";
  import type { Swiper as SwiperSlider } from "swiper/types";
  import CatalogPopup from "@/components/_partials/CatalogPopup.vue";
  import LotDetailsPopup from "@/components/_partials/LotDetailsPopup.vue";
  import LotCard from "@/components/LotCard.vue";
  import { ILot } from "@/models";
  import { LotSoldStatuses, LotStatuses } from "@/enum";
  import Preloader from "@/components/_partials/Preloader.vue";
  import { ArrowsDoubleIcon, BaseIcon } from "@/components/icons";
  import FilterSearch from "@/components/_partials/catalog/FilterSearch.vue";
  import LiveLotAlertPopup from "@/components/_partials/LiveLotAlertPopup.vue";
  import apiClient from "@/services/api";
  import { trans } from "@/utils/trans";
  import { AuthPopup } from "@/components/_partials/lot-info-popup";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Catalog',
  setup(__props) {

  const activeItem = ref<string | null>(null);
  const activeItemSlideIndex = ref<number | null>(null);
  const component = markRaw(LotDetailsPopup);
  const auctionStore = useAuctionStore();
  const lotDetailsPopup = ref<typeof Popup>();
  const popupCatalog = ref<typeof CatalogPopup>();
  const swiperMap = ref<Record<string, SwiperSlider>>({});
  const isShowScrollBack = ref(false);
  const activeGroupLotNumbers = ref([]);
  const authPopupRef = ref<HTMLDivElement>(null);
  const scrollBackBtnClass = ref<string>("");
  const activeLotId = computed(() => auctionStore.activeLot?.id ?? null);

  const catalogType = auctionStore.user?.is_admin ? "lotsLiveCatalogSeller" : "lotsLiveCatalog";
  const slidesPerView = auctionStore.user?.is_admin ? 9 : 7;

  const state = reactive({
    isShowCarousel: false,
    showCarouselTimerId: null,
    swiperParams: {
      slidesPerView: 5,
      slidesPerGroup: 5
    },
    updateParamsTimerId: null,
    showControls: true,
    isCatalogPopupOpen: false
  });

  const isSearchActive = computed(() => auctionStore.catalog.searchString && auctionStore.catalog.searchString?.length);

  const isShowMyBidsTabs = computed(() => {
    return ["my-bids", "current-bids", "won-lots", "didnt-win-lots"].includes(activeItem.value);
  });

  const auctionLots = computed(() => {
    return isSearchActive.value ? auctionStore.catalog.searchLots : auctionStore.lots;
  });

  const lotsUnsold = computed(() => {
    return (
      auctionLots.value?.filter((i: ILot) => {
        return i.sold_status === LotSoldStatuses.UNSOLD;
      }) || []
    );
  });

  const lotsSold = computed(() => {
    return (
      auctionLots.value?.filter((i: ILot) => {
        return i.sold_status === LotSoldStatuses.SOLD;
      }) || []
    );
  });

  const favoriteLots = computed(() => {
    return (
      auctionLots.value?.filter((i: ILot) => {
        return auctionStore.user?.favorite_lots?.includes(i.id);
      }) || []
    );
  });

  const lotsWithUserBid = computed(() => {
    return (
      auctionLots.value?.filter((i: ILot) => {
        return auctionStore.user?.bids && i.id in auctionStore.user.bids;
      }) || []
    );
  });

  const currentBidsList = computed(() => {
    return (
      lotsWithUserBid?.value.filter((i: ILot) => {
        return i.status === LotStatuses.PREPARED;
      }) || []
    );
  });
  const wonLotsList = computed(() => {
    return (
      lotsWithUserBid?.value.filter((i: ILot) => {
        return (
          i.status === LotStatuses.ENDED &&
          i.sold_status === LotSoldStatuses.SOLD &&
          i.leader_id === auctionStore.user?.id
        );
      }) || []
    );
  });
  const didntWonLotsList = computed(() => {
    return (
      lotsWithUserBid?.value.filter((i: ILot) => {
        return (
          i.status === LotStatuses.ENDED &&
          i.sold_status === LotSoldStatuses.SOLD &&
          i.leader_id !== auctionStore.user?.id
        );
      }) || []
    );
  });

  const lotsNotes = computed(() => {
    return (
      auctionLots.value?.filter((i: ILot) => {
        return auctionStore.user?.is_admin ? i.has_admin_notes : i.note?.length;
      }) || []
    );
  });

  const updateShowScrollBack = () => {
    let result = false;
    if (activeItem.value && activeLotId.value) {
      const swiperData = swiperMap.value[activeItem.value];
      if (swiperData) {
        let halfSlidesPV = Math.ceil(swiperData.swiper.params.slidesPerView / 2);
        halfSlidesPV = halfSlidesPV == 2 ? 3 : halfSlidesPV;
        swiperData.slides.forEach((slide, i: number) => {
          if (parseInt(slide.dataset.id) === activeLotId.value) {
            if (
              i !== activeItemSlideIndex.value &&
              ((activeItemSlideIndex.value >= halfSlidesPV && i < halfSlidesPV) || i >= halfSlidesPV)
            ) {
              result = true;
            }
          }
        });
      }
    }

    isShowScrollBack.value = result;
  };

  watch(
    () => auctionStore.activeLot,
    (nv) => {
      if (activeItem.value && nv?.id && !isShowScrollBack.value) {
        const swiperData = swiperMap.value[activeItem.value];
        if (swiperData?.swiper) {
          swiperData.slides.forEach((slide, i: number) => {
            if (parseInt(slide.dataset.id) === nv.id) {
              swiperData.swiper.slideTo(i);
            }
          });
        }
      }
    }
  );

  watch(
    () => auctionLots.value,
    () => {
      nextTick(() => {
        updateShowScrollBack();
        updateSwiperSlides();
      });
    }
  );

  watch(
    () => activeItem.value,
    () => {
      activeGroupLotNumbers.value = [];
      nextTick(() => {
        updateSwiperParams();
        updateShowScrollBack();
      });
    }
  );

  watch(
    () => isShowScrollBack.value,
    (nv) => {
      scrollBackBtnClass.value = "";
      if (nv) {
        setTimeout(() => {
          scrollBackBtnClass.value = "flashing-scroll-back";
        }, 30000);
      }
    }
  );

  const tabs = computed(() => [
    {
      key: "catalog",
      name: "live.catalog.filters.catalog",
      items: auctionLots.value,
      params: {
        class: "with-navigation-numbers lots-list",
        slidesPerView: slidesPerView,
        type: catalogType
      }
    },
    ...(!auctionStore.user?.is_admin
      ? [
          {
            key: "my-bids",
            name: "live.catalog.filters.my_bids",
            notFoundLabel: "live.catalog.filters.my_bids_not_found",
            items: lotsWithUserBid.value,
            isNeedAuth: true,
            params: {
              class: "lots-list",
              slidesPerView: slidesPerView,
              type: catalogType
            }
          }
        ]
      : []),
    ...(!auctionStore.user?.is_admin && isShowMyBidsTabs.value
      ? [
          {
            key: "current-bids",
            name: "live.catalog.filters.current",
            notFoundLabel: "live.catalog.filters.current_not_found",
            items: currentBidsList.value,
            params: {
              titleClass: "subtab-title",
              class: "lots-list",
              slidesPerView: slidesPerView,
              type: catalogType
            }
          }
        ]
      : []),
    ...(!auctionStore.user?.is_admin && isShowMyBidsTabs.value
      ? [
          {
            key: "won-lots",
            name: "live.catalog.filters.won",
            notFoundLabel: "live.catalog.filters.won_not_found",
            items: wonLotsList.value,
            params: {
              titleClass: "subtab-title",
              class: "lots-list",
              slidesPerView: slidesPerView,
              type: catalogType
            }
          }
        ]
      : []),
    ...(!auctionStore.user?.is_admin && isShowMyBidsTabs.value
      ? [
          {
            key: "didnt-win-lots",
            name: "live.catalog.filters.didnt_win",
            notFoundLabel: "live.catalog.filters.didnt_win_not_found",
            items: didntWonLotsList.value,
            params: {
              titleClass: "subtab-title",
              class: "lots-list",
              slidesPerView: slidesPerView,
              type: catalogType
            }
          }
        ]
      : []),
    //=========================
    ...(auctionStore.user?.is_admin
      ? [
          {
            key: "sold",
            name: "live.catalog.filters.sold",
            items: lotsSold.value,
            params: {
              class: "lots-list",
              slidesPerView: slidesPerView,
              type: catalogType
            }
          },
          {
            key: "unsold",
            name: "live.catalog.filters.unsold",
            items: lotsUnsold.value,
            params: {
              class: "lots-list",
              slidesPerView: slidesPerView,
              type: catalogType
            }
          }
        ]
      : []),
    {
      key: "saved-lots",
      name: auctionStore.user?.is_admin ? "live.catalog.filters.saved" : "live.catalog.filters.saved_lots",
      notFoundLabel: "live.catalog.filters.saved_lots_not_found",
      items: favoriteLots.value,
      isNeedAuth: true,
      params: {
        class: "lots-list",
        slidesPerView: slidesPerView,
        type: catalogType
      }
    },
    ...(auctionStore.user?.id
      ? [
          {
            key: "notes",
            name: "live.catalog.filters.notes",
            notFoundLabel: "live.catalog.filters.notes_not_found",
            items: lotsNotes.value,
            params: {
              class: "lots-list",
              slidesPerView: slidesPerView,
              type: catalogType
            }
          }
        ]
      : [])
  ]);

  onMounted(() => {
    activeItem.value = tabs.value[0].key;
  });

  const onSliderInit = (swiper: SwiperSlider, key: string) => {
    swiperMap.value[key] = { swiper, slides: Array.from(swiper.slidesEl.querySelectorAll("swiper-slide")) };

    swiper.on("slideChange", () => updateSwiperParams());
    swiper.on("breakpoint", () => {
      updateSwiperParams();
      updateShowScrollBack();
    });
    swiper.on("sliderMove", showCarousel);
    swiper.on("scrollbarDragMove", showCarousel);
    swiper.on("activeIndexChange", (sw) => {
      activeItemSlideIndex.value = sw.activeIndex;
      updateShowScrollBack();
    });

    if (key === "catalog" && swiperMap.value["catalog"] && activeLotId.value) {
      swiperMap.value["catalog"].slides.forEach((slide, i: number) => {
        if (parseInt(slide.dataset.id) === activeLotId.value) {
          swiperMap.value["catalog"].swiper.slideTo(i);
        }
      });
    }
  };

  const showCarousel = () => {
    state.isShowCarousel = true;

    if (state.showCarouselTimerId) {
      clearTimeout(state.showCarouselTimerId);
    }

    state.showCarouselTimerId = setTimeout(() => {
      state.isShowCarousel = false;
    }, 1000);
  };

  const updateActiveGroupLotNumbers = () => {
    if (activeItem.value && swiperMap.value && swiperMap.value[activeItem.value]?.swiper) {
      swiperMap.value[activeItem.value].slides = Array.from(swiperMap.value[activeItem.value].swiper.slidesEl.querySelectorAll("swiper-slide"))
    }
    const swiperData = swiperMap.value[activeItem.value];

    const result = new Array(Math.min(state.swiperParams.slidesPerView, swiperData?.slides.length) || 0);

    if (swiperData?.swiper && swiperData?.slides?.length) {
      const activeIndex = swiperData.swiper.activeIndex;
      const slidesPerView = state.swiperParams.slidesPerView;
      const totalSlides = swiperData.slides.length;
      const halfPerView = parseInt(state.swiperParams.slidesPerView / 2);

      const start = activeIndex >= halfPerView ? activeIndex - halfPerView : 0;
      const end = start + slidesPerView <= totalSlides ? start + slidesPerView : totalSlides;

      swiperData.slides.slice(start, end).forEach((slide, i: number) => {
        result[i] = { number: slide.dataset.number, isActive: start + i === activeIndex };
      });
    }

    activeGroupLotNumbers.value = result?.every((i) => !i?.number) ? null : result;
  };

  const updateSwiperSlides = () => {
    Object.keys(swiperMap.value).forEach((key) => {
      const swiper = swiperMap.value[key].swiper;
      swiperMap.value[key].slides =
        swiper.slidesEl && !swiper.slidesEl.destroyed
          ? Array.from(swiper.slidesEl.querySelectorAll("swiper-slide"))
          : [];
    });
    nextTick(() => {
      updateSwiperParams();
    });
  };

  const updateSwiperParams = () => {
    if (state.updateParamsTimerId) {
      clearTimeout(state.updateParamsTimerId);
      state.updateParamsTimerId = null;
    }
    state.updateParamsTimerId = setTimeout(() => {
      Object.entries(swiperMap.value).forEach(([key, sliderData]) => {
        if (key === activeItem.value && sliderData?.swiper?.params) {
          const params = swiperMap.value[activeItem.value]?.swiper.params;
          const slides = swiperMap.value[activeItem.value]?.slides;
          state.showControls = slides?.length > 0 && params.slidesPerView * params.grid.rows < slides?.length;

          nextTick(() => {
            sliderData.swiper.update();
            if (state.showControls) {
              sliderData.swiper.scrollbar.enable();
            } else {
              sliderData.swiper.scrollbar.disable();
            }
          });
          state.swiperParams.slidesPerView = sliderData.swiper.params.slidesPerView;
          state.swiperParams.slidesPerGroup = sliderData.swiper.params.slidesPerGroup;
        }
      });
      nextTick(() => updateActiveGroupLotNumbers());
    }, 50);
  };

  const slideToActive = () => {
    if (activeItem.value && activeLotId.value) {
      const swiperData = swiperMap.value[activeItem.value];
      if (swiperData?.swiper) {
        swiperData.slides.forEach((slide, i: number) => {
          if (parseInt(slide.dataset.id) === activeLotId.value) {
            activeItemSlideIndex.value = swiperData?.swiper.activeIndex;
            swiperData.swiper.slideTo(i);
            isShowScrollBack.value = false;
          }
        });
      }
    }
  };

  const changeTab = (tab) => {
    state.showControls = false;
    if (tab.isNeedAuth && !auctionStore.user?.id) {
      authPopupRef.value?.open();
    } else {
      activeItem.value = tab.key;
      nextTick(slideToActive);
    }
  };

  const openLotDetailsPopup = (lot: ILot, lotIndex?: number, isNavigation = false) => {
    // Get current tab's lots
    const currentTab = tabs.value.find(tab => tab.key === activeItem.value);
    const currentTabLots = currentTab?.items || [];
    
    // Find lot index if not provided
    const currentIndex = lotIndex !== undefined 
      ? lotIndex 
      : currentTabLots.findIndex(l => l.id === lot.id);

    apiClient.get(`/live/lots/${lot.id}/popup-data`).then((response) => {
      const componentProps = {
        lotProp: Object.assign(lot, response.data),
        allLots: currentTabLots,
        currentLotIndex: currentIndex,
        onNavigateToLot: (nextLot: ILot, nextIndex: number) => {
          openLotDetailsPopup(nextLot, nextIndex, true);
        }
      };
      
      lotDetailsPopup.value?.toggleComponent(component, componentProps);
      if (!isNavigation) {
        lotDetailsPopup.value?.open();
      }
    });
  };

  const openCatalogPopup = () => {
    popupCatalog.value?.open();
    state.isCatalogPopupOpen = true;
  };

return (_ctx: any,_cache: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(auctionStore).lots?.length || isSearchActive.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["lots-tabs", { 'is-show-my-bids-tab': isShowMyBidsTabs.value }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["type-lots-tab-title tab-title", [{ active: activeItem.value === tab.key }, tab.params.titleClass]]),
                    "data-target": "lot-tab-content-1",
                    onClick: ($event: any) => (changeTab(tab)),
                    key: tab.key
                  }, _toDisplayString(_unref(trans)(tab.name)), 11, _hoisted_3))
                }), 128))
              ], 2),
              (isShowScrollBack.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: _normalizeClass(['scroll-back-button', scrollBackBtnClass.value]),
                    onClick: slideToActive
                  }, [
                    _createVNode(_unref(BaseIcon), {
                      "icon-name": "arrows-double",
                      width: "14",
                      height: "14",
                      viewBox: "0 -960 960 960"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowsDoubleIcon))
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(trans)("live.catalog.scroll_to_live")), 1)
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(FilterSearch, { class: "search-block" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("svg", { class: "icon-search" }, [
                      _createElementVNode("use", { href: "/sprite.svg#search" })
                    ], -1)
                  ])),
                  _: 1
                }),
                _createElementVNode("div", {
                  onClick: openCatalogPopup,
                  class: "catalog-popup-btn"
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("div", { class: "icon-maximize" }, null, -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["tab-content", { active: tab.key === activeItem.value }]),
                  key: tab.key
                }, [
                  _createVNode(Swiper, {
                    id: tab.key,
                    class: _normalizeClass(tab.params.class),
                    "slides-per-view": tab.params.slidesPerView,
                    pagination: false,
                    navigation: state.showControls,
                    scrollbar: state.showControls,
                    mousewheel: true,
                    "centered-slides": true,
                    "centered-slides-bounds": true,
                    "free-mode": { enabled: true, sticky: true },
                    type: tab.params.type,
                    customEventNavigationButtonsClick: true,
                    onSwiperInit: (swiper) => onSliderInit(swiper, tab.key)
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.items, (lot) => {
                        return (_openBlock(), _createBlock(_component_swiper_slide, {
                          key: lot.id,
                          class: "slide-lot swiper-slide",
                          "data-number": lot.lot_number,
                          "data-id": lot.id,
                          onClick: ($event: any) => (openLotDetailsPopup(lot))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(LotCard, { "lot-data": lot }, null, 8, ["lot-data"])
                          ]),
                          _: 2
                        }, 1032, ["data-number", "data-id", "onClick"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["id", "class", "slides-per-view", "navigation", "scrollbar", "type", "onSwiperInit"]),
                  (tab.items.length === 0 && tab.notFoundLabel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(trans)(tab.notFoundLabel)), 1))
                    : _createCommentVNode("", true),
                  (activeGroupLotNumbers.value?.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(['catalog-lot-carousel', { show: state.isShowCarousel }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeGroupLotNumbers.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass([{ active: item?.isActive }]),
                            key: item.id
                          }, _toDisplayString(item.number), 3))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ], 64))
        : (_openBlock(), _createBlock(Preloader, {
            key: 1,
            class: "load-catalog"
          }))
    ]),
    _createVNode(Popup, {
      class: "lot-details-popup full-width",
      ref_key: "lotDetailsPopup",
      ref: lotDetailsPopup
    }, null, 512),
    _createVNode(CatalogPopup, {
      class: "live-catalog-modal",
      ref_key: "popupCatalog",
      ref: popupCatalog,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (state.isCatalogPopupOpen = false))
    }, null, 512),
    _createVNode(LiveLotAlertPopup),
    _createVNode(_unref(AuthPopup), {
      message: _unref(trans)('live.modals.auth_filter_tabs.message'),
      ref_key: "authPopupRef",
      ref: authPopupRef
    }, null, 8, ["message"])
  ], 64))
}
}

})